import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatDialog } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { ActivatedRoute } from '@angular/router';

import { SubsidiaryStudentService } from 'src/app/services/http/business/subsidiary/dashboard/subsidiary-student.service';
import { SubsidiaryContractService } from 'src/app/services/http/business/subsidiary/dashboard/subsidiary-contract.service';
import { SubsidiaryPlacementEntryComponent } from '../subsidiary-placement-entry/subsidiary-placement-entry.component';
import { environment } from 'src/environments/environment';
import { SubsidiaryRegisterEntryComponent } from '../subsidiary-register-entry/subsidiary-register-entry.component';
import { SubsidiaryPlacementInvoiceComponent } from '../subsidiary-placement-invoice/subsidiary-placement-invoice.component';
import { InvoiceService } from 'src/app/services/http/business/invoice/invoice.service';
import { SubsidiaryRegistrationInvoiceComponent } from '../subsidiary-registration-invoice/subsidiary-registration-invoice.component';
// import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
// import { IConfirm } from 'src/app/interfaces/confirm';
import { RegistrationService } from 'src/app/services/http/business/registration/registration.service';
import { SubsidiaryDashboardImportStudentFilesComponent } from '../../subsidiary-dashboard/subsidiary-dashboard-contract/subsidiary-dashboard-import-student-files/subsidiary-dashboard-import-student-files.component';
import { SubsidiaryDashboardContractStudentEmptyComponent } from '../../subsidiary-dashboard/subsidiary-dashboard-contract/subsidiary-dashboard-contract-student-empty/subsidiary-dashboard-contract-student-empty.component';
import { AccountSearchComponent } from '../../account/accounts/account-search/account-search.component';
import { IConfirm } from 'src/app/interfaces/confirm';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { IError } from 'src/app/interfaces/error.interface';
// import { SoundEnum } from 'src/app/enums/sound.enum';
// import { SnackBarService } from 'src/app/services/common/snackBar.service';

@Component({
  selector: 'app-subsidiary-students',
  templateUrl: './subsidiary-students.component.html',
  styleUrls: ['./subsidiary-students.component.css']
})
export class SubsidiaryStudentsComponent implements OnInit {
  filter: any;
  customer: any;
  dataSource = new MatTableDataSource();
  baseUrl = environment.BaaseUrl;

  displayedColumns: string[] = [
    "FullName",
    "Nationalcode",
    "CellPhoneNumber",
    "CustomerContractTitle",
    "placement",
    "Gender",
    "registered",
    "function"
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  pageSize: number;
  pageIndex: number;
  queryParams: any;
  contract: any;

  param: any;
  errorList: IError[] = [];
  errObject: any;
  errors = new Array();

  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog,
    public translate: TranslateService,
    // private snackBar: SnackBarService,
    public invoiceService: InvoiceService,
    private errorService: ErrorsService,
    public registrationService: RegistrationService,
    private snackBar: SnackBarService,
    private subsidiaryStudentService: SubsidiaryStudentService,
    private subsidiaryContractService: SubsidiaryContractService,

  ) {
  }

  ngOnInit() {

    this.route.paramMap.subscribe(params => {
      this.filter = params["params"];
    });
    // this.getContractById();
    this.refresh();
    //this.calcAghPlacementInvoice();
    //this.calcAghRegistrationInvoice();
  }

  getLevelName(LevelPrerequisiteHolding: any) {
    return LevelPrerequisiteHolding.filter(function (e) {
      return e.RelationTypeId == 3
    })[0].PackageName + ' - ' + LevelPrerequisiteHolding.filter(function (e) {
      return e.RelationTypeId == 3
    })[0].LevelName
  }

  getContractById() {
    this.subsidiaryContractService.getContract(this.filter).subscribe(
      res => {
        this.contract = res.DataList[0];
      }
    );
  }

  search() {
    this.dialog
      .open(AccountSearchComponent, {
        width: '300px',
        data: null
      })
      .afterClosed()
      .subscribe(res => {
        this.filter = {
          ContractId: this.filter.ContractId,
          Nationalcode: res.NationalCode,
          FullName: res.FullName,
          PhoneNumber: res.PhoneNumber
        }
        this.refresh();
      });
  }

  // calcAghPlacementInvoice() {

  // }

  // calcAghRegistrationInvoice() {
  //   this.invoiceService.calcAghRegistrationInvoice(this.filter.ContractId).subscribe(
  //     res => {
  //       console.log(res);

  //     }
  //   );
  // }



  refresh() {
    this.subsidiaryStudentService.getStudentsInContract(this.filter).subscribe(
      res => {

        this.paginator.pageSize = 10;
        this.paginator.length = res.Total;
        this.pageIndex = 0;
        this.paginator.length = res.Total;
        this.dataSource = new MatTableDataSource(res.DataList);
      }
    );
  }

  paginatorEvent(event) {
    this.subsidiaryStudentService.getStudentsInContract(this.filter, event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.pageSize = event.pageSize;
        this.paginator.length = res.Total;
        this.pageIndex = event.pageIndex + 1;
        this.dataSource = new MatTableDataSource(res.DataList);
      });
  }


  importFile() {

    this.dialog
      .open(SubsidiaryDashboardImportStudentFilesComponent, {
        width: "300px",
        data: this.filter,
        disableClose: true
      })
      .afterClosed()
      .subscribe(() => {

        this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex - 1 });
      });
  }

  addStudent() {

    this.dialog
      .open(SubsidiaryDashboardContractStudentEmptyComponent, {
        width: "950px",
        // height:"950px",
        data: this.filter,
        disableClose: true
      })
      .afterClosed()
      .subscribe(() => {
        this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex - 1 });
      });
  }

  placement(params: any) {
    this.dialog.open(SubsidiaryPlacementEntryComponent, {
      width: "350px",
      data: params,
      disableClose: false
    })
      .afterClosed()
      .subscribe(() => {

        this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex - 1 });
      });
  }

  register(params: any) {
    params.ContractId = this.filter.ContractId
    this.dialog.open(SubsidiaryRegisterEntryComponent, {
      width: "90%",
      data: params,
      disableClose: false
    })
      .afterClosed()
      .subscribe(() => {
        this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex - 1 });
      });
  }

  delete(params: any) {
    const confirm: IConfirm = {
      accept: true,
      message: "آیا از حذف دانشجو از قرارداد اطمینان دارید؟",
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog
      .open(ConfirmComponent, {
        width: "500px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          var data = {
            NationalCode: params.Nationalcode,
            CustomerContractId: this.filter.ContractId
          }
          this.registrationService.removeAghRegistration(data).subscribe(() => {
            this.snackBar.OpenSnackBar(
              'دانشجو از قرارداد حذف گردید',
              "ok",
              5000,
              SoundEnum.beep
            );
            this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex - 1 });
          }, err => {
            // this.errObject = this.errorService.getError(err);
            // this.param = this.errorService.objectError(this.errObject);
            // this.errors = this.errorService.returnError(err);
            this.errorList = this.errorService.getErrorList(err.error);
          })
        }
      });
  }

  addPlacementInvoice() {
    this.invoiceService.calcAghPlacementInvoice(this.filter.ContractId).subscribe(
      res => {
        this.dialog.open(SubsidiaryPlacementInvoiceComponent, {
          width: "550px",
          data: {
            invoice: res,
            contractId: this.filter.ContractId
          }
        });
      }
    );
  }

  addRegistrationInvoice() {
    this.invoiceService.calcAghRegistrationInvoice(this.filter.ContractId).subscribe(
      res => {
        this.dialog.open(SubsidiaryRegistrationInvoiceComponent, {
          width: "550px",
          data: {
            invoice: res,
            contractId: this.filter.ContractId
          }
        });
      }
    );
  }

}
